import { render, staticRenderFns } from "./VisorViewer.vue?vue&type=template&id=22753937&scoped=true"
import script from "./VisorViewer.vue?vue&type=script&lang=js"
export * from "./VisorViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22753937",
  null
  
)

export default component.exports